module.exports = __webpack_public_path__ + "media/images/ln/constellation_11-758fed3dcbd79cdcc709993c64406e86.png";